import { Box, FlexBox } from "components/common";
import React, { useCallback } from "react";
import styled from "styled-components";
import bgImg from "assets/images/offer_bg.png";
import UCDBackground from "assets/images/ucd-wp.png";
import UCDPDF from "assets/documents/ucd.pdf";
import { AvatarCard } from "components/AvatarCard";

const Root = styled.div`
  background-color: ${props => props.theme.colors.primary.white};
  padding: 9.7rem 0 13rem;
  position: relative;
`;

const Title = styled.div`
  font-size: 3.6rem;
  font-weight: ${props => props.theme.fontWeight.black};
  color: ${props => props.theme.colors.primary.black};
  text-align: center;
  text-transform: uppercase;
`;

const Desc = styled.div`
  font-size: 3.6rem;
  line-height: 4.5rem;
  font-weight: ${props => props.theme.fontWeight.extraLight};
  color: ${props => props.theme.colors.primary.black};
  margin-top: 1rem;
  max-width: 77.6rem;
  text-align: center;
`;

const BackgroundImg = styled.img`
  height: 29rem;
  position: absolute;
  bottom: 2rem;
  right: 0;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 8rem;
  max-width: 80%;
  margin: 0 auto;
`;

const DocTitle = styled.div`
  font-size: 2.5rem;
  font-weight: ${props => props.theme.fontWeight.semiBold};
  color: ${props => props.theme.colors.primary.dark};
  margin-top: 3rem;
`;

export const Research = () => {
  return (
      <Root>
        <BackgroundImg src={bgImg} />

        <FlexBox flexDirection="column" alignItems="center" className="container">
          {
            Sections.map((section, index) => {
              const { title, desc, documents } = section;
              return (
                  <>
                    <Box marginBottom="9rem" key={`section-${index}`}>
                      <Title>{title}</Title>
                      <Desc>{desc}</Desc>
                    </Box>
                    <GridContainer>
                      {
                        documents.length === 0
                            ? <DocTitle>Coming Soon!</DocTitle>
                            : documents.map((member, index) => {
                                const { img, name} = member;
                                return (
                                    <a rel="noreferrer" href={UCDPDF} target="_blank" key={`offer-${index}`}>
                                      <AvatarCard
                                          {...{ img, name }}
                                      />
                                      <DocTitle>
                                        {name}
                                      </DocTitle>
                                    </a>

                                );
                        })
                      }
                    </GridContainer>
                  </>

              );
            })
          }
        </FlexBox>
      </Root>
  );
};

const Sections = [
  {
    title: "Case Studies",
    desc: "Real Stories, Real Results",
    documents: [
      {
        name: "Revolutionizing English Grammar Lessons Through User-Centered Design",
        description: "",
        img: UCDBackground,
      }
    ]
  }, {
    title: "White Papers",
    desc: "Data-Driven Insights",
    documents: []
  }
]

const DOCUMENTS = [
  {
    name: "Revolutionizing English Grammar Lessons Through User-Centered Design",
    description: "",
    img: UCDBackground,
  }
];
